'use client'

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

export function ThemeToggle() {
	const { theme, setTheme, resolvedTheme } = useTheme()
	const [mounted, setMounted] = useState(false)

	useEffect(() => { setMounted(true) }, [])

	const isDark = resolvedTheme === 'dark'
	const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark')

	if (!mounted) {
		return (
			<div className="flex items-center gap-0.5 p-0.5 rounded-md border border-border bg-background">
				<div className="w-6 h-6 rounded-full bg-muted flex items-center justify-center"><Sun className="h-3.5 w-3.5" /></div>
				<div className="w-6 h-6 rounded-full flex items-center justify-center"><Moon className="h-3.5 w-3.5" /></div>
			</div>
		)
	}

	return (
		<div
			className={`theme-toggle flex items-center gap-0.5 p-0.5 rounded-md border cursor-pointer hover:bg-muted/20 transition-colors ${isDark ? 'border-border/50 bg-background/50' : 'border-border bg-background'}`}
			onClick={toggleTheme}
		>
			<div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${!isDark ? 'theme-toggle-active shadow-sm' : ''}`}>
				<Sun className="h-3.5 w-3.5" />
			</div>
			<div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isDark ? 'theme-toggle-active shadow-sm' : ''}`}>
				<Moon className="h-3.5 w-3.5" />
			</div>
		</div>
	)
}
